webpackJsonp([1],{

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query EntriesForMap($map: String!) {\n    map: Map(slug: $map) {\n      id,\n      name,\n      minimap,\n      minimapSize,\n      entries {\n        id,\n        createdAt,\n        description,\n        downvotes,\n        upvotes,\n        locations,\n        name,\n        type {\n          id,\n          name\n          color,\n        },\n        usage,\n        video {\n          videoId,\n          start,\n          end\n        },\n        user {\n          name\n        }\n      }\n    }\n  }\n'], ['\n  query EntriesForMap($map: String!) {\n    map: Map(slug: $map) {\n      id,\n      name,\n      minimap,\n      minimapSize,\n      entries {\n        id,\n        createdAt,\n        description,\n        downvotes,\n        upvotes,\n        locations,\n        name,\n        type {\n          id,\n          name\n          color,\n        },\n        usage,\n        video {\n          videoId,\n          start,\n          end\n        },\n        user {\n          name\n        }\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query GameMaps($game: String) {\n    game: Game(slug: $game) {\n      id,\n      name,\n      maps {\n        id,\n        name,\n        slug,\n        thumbnail\n      }\n    }\n  }\n'], ['\n  query GameMaps($game: String) {\n    game: Game(slug: $game) {\n      id,\n      name,\n      maps {\n        id,\n        name,\n        slug,\n        thumbnail\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query {\n    user {\n      id,\n      name,\n      picture,\n      upvoted {\n        id\n      },\n      downvoted {\n        id\n      }\n    }\n  }\n'], ['\n  query {\n    user {\n      id,\n      name,\n      picture,\n      upvoted {\n        id\n      },\n      downvoted {\n        id\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_auth0_lock__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_auth0_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_auth0_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__);



var AUTH0_CLIENT_ID = 'GwNOClBkpC2TiE0dcDUGWroXexizYxr3';
var AUTH0_DOMAIN = 'nadespots.eu.auth0.com';

var lock = new __WEBPACK_IMPORTED_MODULE_0_auth0_lock___default.a(AUTH0_CLIENT_ID, AUTH0_DOMAIN, {
  autoclose: true,
  auth: {
    responseType: 'token',
    redirect: false
  },
  theme: {
    logo: __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default.a,
    primaryColor: '#34495e',
    labeledSubmitButton: false
  },
  socialButtonStyle: 'small'
});

/* harmony default export */ __webpack_exports__["a"] = (lock);

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(709),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2de4ac04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
  __webpack_require__(521)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b1d00c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(722),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-882423ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(721),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_Home__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scenes_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__scenes_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_Logout__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scenes_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__scenes_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_Callback__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scenes_Callback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__scenes_Callback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_Disclaimer__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scenes_Disclaimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__scenes_Disclaimer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_Terms__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scenes_Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scenes_Terms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_MapSelection__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenes_MapSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__scenes_MapSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scenes_MapSelection_Add__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scenes_MapSelection_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__scenes_MapSelection_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scenes_Dashboard__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scenes_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__scenes_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scenes_Dashboard_Details__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scenes_Dashboard_Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__scenes_Dashboard_Details__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scenes_Dashboard_Add__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__scenes_Dashboard_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__scenes_Dashboard_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scenes_Dashboard_Add_Details__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scenes_Dashboard_Add_Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__scenes_Dashboard_Add_Details__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scenes_Dashboard_Add_Content__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__scenes_Dashboard_Add_Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__scenes_Dashboard_Add_Content__);



















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__scenes_Home___default.a
  }, {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: __WEBPACK_IMPORTED_MODULE_5__scenes_Disclaimer___default.a
  }, {
    path: '/terms',
    name: 'Terms',
    component: __WEBPACK_IMPORTED_MODULE_6__scenes_Terms___default.a
  }, {
    path: '/callback',
    name: 'Callback',
    component: __WEBPACK_IMPORTED_MODULE_4__scenes_Callback___default.a
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_3__scenes_Logout___default.a
  }, {
    path: '/:game',
    redirect: { name: 'MapSelection' }
  }, {
    path: '/:game/',
    name: 'MapSelection',
    pathToRegexpOptions: { strict: true },
    component: __WEBPACK_IMPORTED_MODULE_7__scenes_MapSelection___default.a,
    children: [{
      path: '/:game/add',
      name: 'MapSelectionAdd',
      component: __WEBPACK_IMPORTED_MODULE_8__scenes_MapSelection_Add___default.a
    }]
  }, {
    path: '/:game/:map',
    redirect: { name: 'Dashboard' }
  }, {
    path: '/:game/:map/',
    name: 'Dashboard',
    pathToRegexpOptions: { strict: true },
    component: __WEBPACK_IMPORTED_MODULE_9__scenes_Dashboard___default.a,
    children: [{
      path: '/:game/:map/add',
      name: 'DashboardAdd',
      component: __WEBPACK_IMPORTED_MODULE_11__scenes_Dashboard_Add___default.a,
      children: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_12__scenes_Dashboard_Add_Details___default.a
      }, {
        path: '/:game/:map/add/details',
        name: 'DashboardAddDetails',
        component: __WEBPACK_IMPORTED_MODULE_12__scenes_Dashboard_Add_Details___default.a
      }, {
        path: '/:game/:map/add/content',
        name: 'DashboardAddContent',
        component: __WEBPACK_IMPORTED_MODULE_13__scenes_Dashboard_Add_Content___default.a
      }]
    }, {
      path: '/:game/:map/:detailId',
      name: 'DashboardDetails',
      component: __WEBPACK_IMPORTED_MODULE_10__scenes_Dashboard_Details___default.a
    }]
  }]
}));

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation AddDownvoteOnUser($user: ID!, $entry: ID!) {\n    addToDownvoteOnUser (\n      downvoteUsersUserId: $user,\n      downvotedEntryId: $entry\n    ) {\n      downvotedEntry {\n        id\n      }\n    }\n  }\n'], ['\n  mutation AddDownvoteOnUser($user: ID!, $entry: ID!) {\n    addToDownvoteOnUser (\n      downvoteUsersUserId: $user,\n      downvotedEntryId: $entry\n    ) {\n      downvotedEntry {\n        id\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation addEntry(\n    $description: String!,\n    $name: String!,\n    $usage: USAGE!,\n    $videoId: String!,\n    $videoStart: Int!,\n    $videoEnd: Int!,\n    $map: ID!,\n    $type: ID!,\n    $locations: Json!,\n    $userId: ID!,\n  ) {\n    createEntry(\n      description: $description,\n      name: $name,\n      usage: $usage,\n      mapId: $map,\n      typeId: $type,\n      locations: $locations,\n      video: {\n        videoId: $videoId,\n        start: $videoStart,\n        end: $videoEnd\n      },\n      userId: $userId                \n    ) {\n      id,\n      createdAt,\n      description,\n      downvotes,\n      upvotes,\n      locations,\n      name,\n      type {\n        id,\n        name\n        color,\n      },\n      usage,\n      video {\n        videoId,\n        start,\n        end\n      },\n      user {\n        name\n      }\n    }\n  }\n'], ['\n  mutation addEntry(\n    $description: String!,\n    $name: String!,\n    $usage: USAGE!,\n    $videoId: String!,\n    $videoStart: Int!,\n    $videoEnd: Int!,\n    $map: ID!,\n    $type: ID!,\n    $locations: Json!,\n    $userId: ID!,\n  ) {\n    createEntry(\n      description: $description,\n      name: $name,\n      usage: $usage,\n      mapId: $map,\n      typeId: $type,\n      locations: $locations,\n      video: {\n        videoId: $videoId,\n        start: $videoStart,\n        end: $videoEnd\n      },\n      userId: $userId                \n    ) {\n      id,\n      createdAt,\n      description,\n      downvotes,\n      upvotes,\n      locations,\n      name,\n      type {\n        id,\n        name\n        color,\n      },\n      usage,\n      video {\n        videoId,\n        start,\n        end\n      },\n      user {\n        name\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createGame($name: String!, $slug: String!) {\n    createGame(\n      name: $name,\n      slug: $slug,\n      typesIds: ["cj59yn1k45rsl0129p1nf7u9k", "cj59yp9gn5txr01244o0d4yd1", "cj59yq3ks5sak0129k9uex52o"]\n    ) {\n      id,\n      name,\n      slug,\n      types {\n        id,\n        name,\n        color\n      }\n    }\n  }\n'], ['\n  mutation createGame($name: String!, $slug: String!) {\n    createGame(\n      name: $name,\n      slug: $slug,\n      typesIds: ["cj59yn1k45rsl0129p1nf7u9k", "cj59yp9gn5txr01244o0d4yd1", "cj59yq3ks5sak0129k9uex52o"]\n    ) {\n      id,\n      name,\n      slug,\n      types {\n        id,\n        name,\n        color\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation AddUpvoteOnUser($user: ID!, $entry: ID!) {\n    addToUpvoteOnUser (\n      upvoteUsersUserId: $user,\n      upvotedEntryId: $entry\n    ) {\n      upvotedEntry {\n        id\n      }\n    }\n  }\n'], ['\n  mutation AddUpvoteOnUser($user: ID!, $entry: ID!) {\n    addToUpvoteOnUser (\n      upvoteUsersUserId: $user,\n      upvotedEntryId: $entry\n    ) {\n      upvotedEntry {\n        id\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createMap(\n    $minimap: String!,\n    $minimapSize: Int!,\n    $name: String!,\n    $slug: String!,\n    $thumbnail: String!,\n    $game: ID!\n    $userId: ID!,\n  ) {\n    createMap(\n      minimap: $minimap,\n      minimapSize: $minimapSize,\n      name: $name,\n      slug: $slug,\n      thumbnail: $thumbnail,\n      gameId: $game,\n      userId: $userId\n    ) {\n      id,\n      minimap,\n      minimapSize,\n      name,\n      slug,\n      thumbnail\n    }\n  }\n'], ['\n  mutation createMap(\n    $minimap: String!,\n    $minimapSize: Int!,\n    $name: String!,\n    $slug: String!,\n    $thumbnail: String!,\n    $game: ID!\n    $userId: ID!,\n  ) {\n    createMap(\n      minimap: $minimap,\n      minimapSize: $minimapSize,\n      name: $name,\n      slug: $slug,\n      thumbnail: $thumbnail,\n      gameId: $game,\n      userId: $userId\n    ) {\n      id,\n      minimap,\n      minimapSize,\n      name,\n      slug,\n      thumbnail\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation ($idToken: String!, $name: String!, $email: String!, $picture: String!){\n    createUser(authProvider: {auth0: {idToken: $idToken}}, name: $name, email: $email, picture: $picture) {\n      id,\n      name,\n      picture\n    }\n  }\n'], ['\n  mutation ($idToken: String!, $name: String!, $email: String!, $picture: String!){\n    createUser(authProvider: {auth0: {idToken: $idToken}}, name: $name, email: $email, picture: $picture) {\n      id,\n      name,\n      picture\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation EditUserName($user: ID!, $name: String!) {\n    updateUser(id: $user, name: $name) {\n      id,\n      name,\n    }\n  }\n'], ['\n  mutation EditUserName($user: ID!, $name: String!) {\n    updateUser(id: $user, name: $name) {\n      id,\n      name,\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query GameTypes($game: String) {\n    game: Game(slug: $game) {\n      id,\n      types {\n        id,\n        color,\n        name\n      }\n    }\n  }\n'], ['\n  query GameTypes($game: String) {\n    game: Game(slug: $game) {\n      id,\n      types {\n        id,\n        color,\n        name\n      }\n    }\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject));

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_client__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_apollo__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_gtm__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(308);























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Setting up Apollo
var networkInterface = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_apollo_client__["a" /* createNetworkInterface */])({
  uri: 'https://api.graph.cool/simple/v1/cj59tz3nfrlhy0105885qy550',
  transportBatching: true
});

// Auth0 middleware
networkInterface.use([{
  applyMiddleware: function applyMiddleware(req, next) {
    if (!req.options.headers) {
      req.options.headers = {};
    }

    // get the authentication token from local storage if it exists
    if (localStorage.getItem('auth0IdToken')) {
      req.options.headers.authorization = 'Bearer ' + localStorage.getItem('auth0IdToken');
    }
    next();
  }
}]);

var apolloClient = new __WEBPACK_IMPORTED_MODULE_2_apollo_client__["b" /* ApolloClient */]({
  // networkInterface: networkInterfaceWithSubscriptions,
  networkInterface: networkInterface,
  ssrForceFetchDelay: 100,
  connectToDevTools: true
});

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_3_vue_apollo__["a" /* default */]({
  clients: {
    a: apolloClient
  },
  defaultClient: apolloClient
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_apollo__["a" /* default */]);

// Setting up Google Maps
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyB5Bito_jYPWhhjLWyX9FcUpZyKASo7jtM'
  }
});

// Setting up meta plugin
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_meta___default.a);

// Setting up Youtube player
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_youtube_embed__["a" /* default */]);

// Setting up form validation
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);

// Setting up Google Tag Manager
if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_gtm___default.a, {
    vueRouter: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */]
  });
}

// Setting up sentry
__WEBPACK_IMPORTED_MODULE_7_raven_js___default.a.config('https://95cb59a8fd7645178268af19ef42e582@sentry.io/207572').addPlugin(__WEBPACK_IMPORTED_MODULE_8_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();

// Clear the div
document.getElementById('app').innerHTML = '';

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
  apolloProvider: apolloProvider,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_11__App___default.a }
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* eslint-disable */

var cache = {};

var generateTile = function generateTile(name, sourceImg, tileSize, coord, zoom) {
  var ownerDocument = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : document;

  var id = name + '/' + coord.x + '/' + coord.y + '/' + zoom;

  // Return the result if it has been generated before
  if (cache[id]) {
    return cache[id];
  }

  var c = Math.pow(2, zoom);
  var tilex = coord.x,
      tiley = coord.y;
  if (_this.imageWraps) {
    if (tilex < 0) tilex = c + tilex % c;
    if (tilex >= c) tilex = tilex % c;
    if (tiley < 0) tiley = c + tiley % c;
    if (tiley >= c) tiley = tiley % c;
  } else {
    if (tilex < 0 || tilex >= c || tiley < 0 || tiley >= c) {
      var blank = ownerDocument.createElement('DIV');
      blank.style.width = tileSize.width + 'px';
      blank.style.height = tileSize.height + 'px';
      return blank;
    }
  }

  var img = ownerDocument.createElement('img');

  img.id = "t_" + zoom + "_" + tilex + "_" + tiley;
  img.style.width = tileSize.width + 'px';
  img.style.height = tileSize.height + 'px';

  var canvas = ownerDocument.createElement('canvas');
  canvas.width = tileSize.width;
  canvas.height = tileSize.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(sourceImg, sourceImg.width / Math.pow(2, zoom) * tilex, sourceImg.height / Math.pow(2, zoom) * tiley, sourceImg.width / Math.pow(2, zoom), sourceImg.height / Math.pow(2, zoom), 0, 0, tileSize.width, tileSize.height);

  var dataUrl = canvas.toDataURL();
  cache[id] = dataUrl;
  return dataUrl;
};

/* harmony default export */ __webpack_exports__["a"] = (generateTile);

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-disqus',
  props: {
    shortname: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    remote_auth_s3: {
      type: String,
      required: false
    },
    api_key: {
      type: String,
      required: false
    },
    sso_config: {
      type: Object,
      required: false
    },
    language: {
      type: String,
      required: false
    }
  },
  mounted: function mounted() {
    if (window.DISQUS) {
      this.reset(window.DISQUS);
      return;
    }
    this.init();
  },

  methods: {
    reset: function reset(dsq) {
      var self = this;
      dsq.reset({
        reload: true,
        config: function config() {
          self.setBaseConfig(this);
        }
      });
    },
    init: function init() {
      var _this = this;

      var self = this;
      window.disqus_config = function () {
        self.setBaseConfig(this);
      };
      setTimeout(function () {
        var d = document,
            s = d.createElement('script');
        s.setAttribute('id', 'embed-disqus');
        s.setAttribute('data-timestamp', +new Date());
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//' + _this.shortname + '.disqus.com/embed.js';(d.head || d.body).appendChild(s);
      }, 0);
    },
    setBaseConfig: function setBaseConfig(disqusConfig) {
      var _this2 = this;

      disqusConfig.page.identifier = this.identifier || this.$route.path || window.location.pathname;
      disqusConfig.page.url = this.url || this.$el.baseURI;
      if (this.title) {
        disqusConfig.page.title = this.title;
      }
      if (this.remote_auth_s3) {
        disqusConfig.page.remote_auth_s3 = this.remote_auth_s3;
      }
      if (this.api_key) {
        disqusConfig.page.api_key = this.api_key;
      }
      if (this.sso_config) {
        disqusConfig.sso = this.sso_config;
      }
      if (this.language) {
        disqusConfig.language = this.language;
      }

      disqusConfig.callbacks.onReady = [function () {
        _this2.$emit('ready');
      }];
    }
  }
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_badges_graphcool_png__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_badges_graphcool_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_badges_graphcool_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_badges_netlify_png__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_badges_netlify_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_badges_netlify_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_badges_github_png__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_badges_github_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_badges_github_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_USER__ = __webpack_require__(220);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      user: null,
      graphcoolBadge: __WEBPACK_IMPORTED_MODULE_0__assets_badges_graphcool_png___default.a,
      netlifyBadge: __WEBPACK_IMPORTED_MODULE_1__assets_badges_netlify_png___default.a,
      githubBadge: __WEBPACK_IMPORTED_MODULE_2__assets_badges_github_png___default.a
    };
  },

  computed: {
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  },
  apollo: {
    user: {
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_USER__["a" /* default */],
      fetchPolicy: 'network-only'
    }
  }
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logo',
  props: ['hideImage', 'noHeader']
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Modal',
  mounted: function mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.overflow = 'auto';
  }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_lock__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_USER__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_MUTATION_CREATE_USER__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_MUTATION_EDIT_USER_NAME__ = __webpack_require__(416);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function checkAuth() {
  return !!localStorage.getItem('id_token');
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserBar',
  data: function data() {
    return {
      isUsernameEditable: false,
      editableUsername: '',
      user: null,
      lock: __WEBPACK_IMPORTED_MODULE_2__services_lock__["a" /* default */]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
      _this.authenticated = checkAuth();

      _this.lock.on('authenticated', function (authResult) {
        console.log('authenticated', authResult);
        localStorage.setItem('auth0IdToken', authResult.idToken);
        _this.lock.getProfile(authResult.idToken, function (error, profile) {
          if (error) {
            // Handle error
            return;
          }

          console.log('auth0 profile', profile);

          // Set the token and user profile in local storage
          localStorage.setItem('profile', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(profile));

          _this.$apollo.query(_this.$apollo.queries.user.options).then(function (data) {
            console.log('Got user', data);
            if (_this.user) {
              // Login
              console.log('everything gucci');
            } else {
              var name = profile.display_name || profile.given_name || profile.nickname || profile.name || profile.email;
              var picture = profile.logo || profile.picture;
              _this.createUser(authResult.idToken, profile.email, name, picture);
            }
          }).catch(function (error) {
            console.log('Didnt get user', error);
          });
        });
      });
      _this.lock.on('authorization_error', function (error) {
        // handle error when authorizaton fails
        console.log('Auth0 error', error);
        return;
      });
    });
  },

  methods: {
    login: function login() {
      this.lock.show();
    },
    logout: function logout() {
      localStorage.removeItem('profile');
      localStorage.removeItem('auth0IdToken');
      window.location.reload();
    },
    handleUserNameEditClick: function handleUserNameEditClick() {
      var _this2 = this;

      this.editableUsername = this.user.name;
      this.isUsernameEditable = true;

      this.$nextTick(function () {
        _this2.$refs.userNameInput.focus();
      });
    },
    handleUserNameInput: function handleUserNameInput(e) {
      console.log('input', e);
      this.editableUsername = e.target.value;
    },
    handleUserNameBlur: function handleUserNameBlur() {
      console.log('blur');
      this.isUsernameEditable = false;
      this.editableUsername = this.user.name;
    },
    handleUserNameKeyPress: function handleUserNameKeyPress(e) {
      if (e.keyCode === 13) {
        this.isUsernameEditable = false;
        this.$apollo.mutate({
          mutation: __WEBPACK_IMPORTED_MODULE_5__graphql_MUTATION_EDIT_USER_NAME__["a" /* default */],
          variables: {
            user: this.user.id,
            name: this.editableUsername
          }
        });
      }
    },
    createUser: function createUser(idToken, email, name, picture) {
      var _this3 = this;

      return this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_MUTATION_CREATE_USER__["a" /* default */],
        variables: {
          idToken: idToken,
          name: name,
          email: email,
          picture: picture
        }
      }).then(function (result) {
        console.log('createUser result: ', result);
        _this3.user = result.data.createUser;
      });
    }
  },
  apollo: {
    user: {
      fetchPolicy: 'network-only',
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_USER__["a" /* default */]
    }
  }
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Callback'
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loader__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_QUERY_ENTRIES_FOR_MAP__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_MUTATION_ADD_ENTRY__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Player__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Player__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var API_KEY = 'AIzaSyC-XJtt6icSgqZDMdZzdt3648vOa_GT9jE';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Content',
  props: ['map', 'user'],
  components: { Loader: __WEBPACK_IMPORTED_MODULE_3__components_Loader___default.a, Player: __WEBPACK_IMPORTED_MODULE_6__components_Player___default.a, VueSlider: __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default.a },
  data: function data() {
    return {
      query: '',
      video: '',
      start: 0,
      end: null,
      valid: false,
      foundVideos: [],
      searchLoading: false,
      max: 100,
      min: 0,
      recording: false,
      recordingStart: 0
    };
  },
  mounted: function mounted() {
    // TODO: Validate params
  },

  computed: {
    doSearch: function doSearch() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(this.search, 400, { trailing: true });
    },
    sliderValues: function sliderValues() {
      var start = this.start == null ? 0 : this.start;
      var end = this.end == null ? 0 : this.end;
      return [parseInt(start, 10), parseInt(end, 10)];
    }
  },
  methods: {
    search: function search() {
      var _this = this;

      this.searchLoading = true;
      var searchUrl = 'https://www.googleapis.com/youtube/v3/search?part=snippet&key=' + API_KEY + '&q=' + this.query;

      fetch(searchUrl).then(function (data) {
        return data.json();
      }).then(function (data) {
        _this.searchLoading = false;
        console.log('youtube data', data);
        _this.foundVideos = data.items;
      });
    },
    handleSearchInput: function handleSearchInput() {
      this.doSearch();
    },
    selectVideo: function selectVideo(videoId) {
      this.video = videoId;
    },
    handleVideo: function handleVideo(player) {
      console.log('handleVideo', player);
      if (!player) return;

      var duration = Math.round(player.getDuration());
      console.log('handleVideoDuration', duration);
      if (duration && this.end !== duration && (this.end === 0 || this.end == null)) this.end = duration;
      if (duration && this.max !== duration) this.max = duration;
    },
    handleDragEnd: function handleDragEnd(e) {
      this.start = e.currentValue[0];
      this.end = e.currentValue[1];
    },
    toHHMMSS: function toHHMMSS(secs) {
      var secNum = parseInt(secs, 10);
      var hours = Math.floor(secNum / 3600) % 24;
      var minutes = Math.floor(secNum / 60) % 60;
      var seconds = secNum % 60;

      return [hours, minutes, seconds].map(function (v) {
        return v < 10 ? '0' + v : v;
      }).filter(function (v, i) {
        return v !== '00' || i > 0;
      }).join(':');
    },
    handleStartRecord: function handleStartRecord() {
      this.recording = true;
      this.recordingStart = this.$refs.player.getCurrentTime();
    },
    handleStopRecord: function handleStopRecord() {
      this.recording = false;

      // Only set the nade when the user recorded long enough
      if (this.$refs.player.getCurrentTime() - this.recordingStart > 3) {
        this.start = this.recordingStart;
        this.end = this.$refs.player.getCurrentTime();
      }
      this.recordingStart = null;
    },
    addEntry: function addEntry() {
      var _this2 = this;

      var gameId = this.$route.params.game;
      var mapId = this.$route.params.map;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_5__graphql_MUTATION_ADD_ENTRY__["a" /* default */],
        variables: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.params, {
          videoId: this.video,
          videoStart: this.start ? parseInt(this.start, 10) : undefined,
          videoEnd: this.end ? parseInt(this.end, 10) : undefined,
          map: this.map.id,
          userId: this.user.id
        }),
        update: function update(store, _ref) {
          var createEntry = _ref.data.createEntry;

          console.log('update', store, createEntry, this);
          var data = store.readQuery({
            query: __WEBPACK_IMPORTED_MODULE_4__graphql_QUERY_ENTRIES_FOR_MAP__["a" /* default */],
            variables: {
              map: gameId + '_' + mapId
            }
          });
          console.log('data', data);
          data.map.entries.push(createEntry);
          store.writeQuery({ query: __WEBPACK_IMPORTED_MODULE_4__graphql_QUERY_ENTRIES_FOR_MAP__["a" /* default */], data: data });
        }
      }).then(function (data) {
        console.log('addEntry success', data);
        _this2.$router.push({ name: 'Dashboard' });
      }).catch(function (error) {
        console.error('addEntry error', error);
      });
    }
  }
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NadeMap__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NadeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NadeMap__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddDetails',
  props: ['types', 'usages', 'minimap'],
  components: { NadeMap: __WEBPACK_IMPORTED_MODULE_3__components_NadeMap___default.a },
  data: function data() {
    return {
      name: '',
      description: '',
      type: null,
      usage: null,
      locations: []
    };
  },

  computed: {
    entry: function entry() {
      var _this = this;

      return {
        type: this.types.filter(function (x) {
          return x.id === _this.type;
        })[0] || this.types[0],
        locations: this.locations
      };
    }
  },
  methods: {
    handleUsageChange: function handleUsageChange(e) {
      this.usage = this.usages[e.target.selectedIndex];
    },
    handleTypeChange: function handleTypeChange(e) {
      console.log('handleTypeChange', e, e.target.selectedIndex);
      this.type = this.types[e.target.selectedIndex].id;
    },
    handleMapClick: function handleMapClick(e) {
      console.log('handleMapClick start', e);

      var location = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(e).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        console.log('key', key, 'value', value);
        if (key === 'latLng') return false;
        if (key === 'pixel') return false;
        if (key === 'va') return false;
        if (!value.x) return false;
        if (!value.y) return false;

        return true;
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        return value;
      })[0];

      console.log('handleMapClick end', location);
      this.locations.push(location);
    },
    handleMapRightClick: function handleMapRightClick() {
      this.locations = [];
    }
  },
  validations: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    locations: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
    }
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Add',
  props: ['user', 'types', 'minimap', 'map'],
  data: function data() {
    return {
      usages: ['GENERAL', 'OFFENSIVE', 'DEFENSIVE']
    };
  }
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_disqus_dist_vue_disqus_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_disqus_dist_vue_disqus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_disqus_dist_vue_disqus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_MUTATION_ADD_UPVOTE_ON_USER__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_MUTATION_ADD_DOWNVOTE_ON_USER__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Player__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Player__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Details',
  props: ['entries', 'user'],
  components: { Player: __WEBPACK_IMPORTED_MODULE_3__components_Player___default.a, VueDisqus: __WEBPACK_IMPORTED_MODULE_0_vue_disqus_dist_vue_disqus_vue___default.a },
  computed: {
    entry: function entry() {
      var _this = this;

      if (!this.entries) return null;
      return this.entries.filter(function (x) {
        return x.id === _this.$route.params.detailId;
      })[0];
    }
  },
  methods: {
    upvote: function upvote() {
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__graphql_MUTATION_ADD_UPVOTE_ON_USER__["a" /* default */],
        variables: {
          user: this.user.id,
          entry: this.entry.id
        }
      });
    },
    downvote: function downvote() {
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__graphql_MUTATION_ADD_DOWNVOTE_ON_USER__["a" /* default */],
        variables: {
          user: this.user.id,
          entry: this.entry.id
        }
      });
    }
  }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generateTile_js__ = __webpack_require__(419);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/**
 * Generates adds intermediate values between coordinates
 * This is done because Google Maps assumes the map is wrapped around a sphere, So it assumes it can pan around the sphere
 * Example: [{ x: 0, y: 0 }, { x: 100, y: 100 }] -> [{ x: 0, y: 0 }, { x: 50, y: 50 }, { x: 100, y: 100 }]
 * @param  {[Object]} input - Array with coordinate objects
 * @return {[Object]} - Array with coordinate objects
 */
function generatePolyPath(input) {
  var result = [];

  for (var i = 0; i < input.length; i++) {
    var current = input[i];
    var next = input[i + 1];

    result.push(current);

    if (next) {
      var newX = (next.x + current.x) / 2;
      var newY = (next.y + current.y) / 2;

      result.push({
        x: newX,
        y: newY
      });
    }
  }

  return result;
}

// Use the DOM setInterval() function to change the offset of the symbol
// at fixed intervals.
function animateCircle(line) {
  var count = 0;
  window.setInterval(function () {
    count = (count + 1) % 200;

    var icons = line.get('icons');
    icons[0].offset = count / 2 + '%';
    line.set('icons', icons);
  }, 20);
}

/**
 * Normalizes the coords that tiles repeat across the x axis (horizontally)
 * Like the standard Google map tiles.
 * @param  {Object} coord - 2d vector containing X, Y values
 * @param  {Int} zoom - Zoom multiplier
 * @return {Object} - 2d vector containing X, Y values
 */
function getNormalizedCoord(coord, zoom) {
  var y = coord.y;
  var x = coord.x;

  // tile range in one direction range is dependent on zoom level
  // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
  var tileRange = 1 << zoom;

  // repeat across y-axis
  if (y < 0 || y >= tileRange) {
    y = (y % tileRange + tileRange) % tileRange;
  }

  // repeat across x-axis
  if (x < 0 || x >= tileRange) {
    x = (x % tileRange + tileRange) % tileRange;
  }

  return { x: x, y: y };
}

function getPixelLocation(map, currentLatLng) {
  var scale = Math.pow(2, map.getZoom());
  var nw = new google.maps.LatLng(map.getBounds().getNorthEast().lat(), map.getBounds().getSouthWest().lng());
  var worldCoordinateNW = map.getProjection().fromLatLngToPoint(nw);
  var worldCoordinate = map.getProjection().fromLatLngToPoint(currentLatLng);
  var currentLocation = new google.maps.Point(Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale), Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale));

  return currentLocation;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Map',
  props: ['name', 'entries', 'minimap', 'draggable'],
  data: function data() {
    return {
      mapTypeId: 'Terrain',
      mapLoaded: false,
      sourceImg: null,
      sourceImgLoaded: false,
      drawnEntries: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.sourceImg = new Image(this.minimap.size, this.minimap.size);
    this.sourceImg.setAttribute('crossOrigin', 'anonymous');
    this.sourceImg.src = this.minimap.url;
    this.sourceImg.addEventListener('load', function () {
      return _this.sourceImgLoaded = true;
    });

    var sourceImgPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      _this.sourceImg.addEventListener('load', function () {
        return resolve();
      });
    });

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$refs.map.$mapPromise, sourceImgPromise]).then(function () {
      _this.handleMapLoaded();
      _this.drawEntriesOnce();
    });

    this.$refs.map.resizePreserveCenter();
    window.addEventListener('resize', this.restoreCenter);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.restoreCenter);
  },

  watch: {
    entries: function entries(newEntries, oldEntries) {
      // Don't do this action when it's the first time
      if (oldEntries) {
        this.drawnEntries.forEach(function (entry) {
          return entry.setMap(null);
        });
        this.drawEntries(newEntries);
      }
    }
  },
  computed: {
    drawEntriesOnce: function drawEntriesOnce() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["once"])(this.drawEntries);
    }
  },
  methods: {
    setCenterPixel: function setCenterPixel(x, y) {
      var projection = this.$refs.map.$mapObject.getProjection();
      var coord = projection.fromPointToLatLng(new google.maps.Point(x, y));

      this.$refs.map.$mapObject.setCenter(coord);
    },
    drawEntries: function drawEntries() {
      var _this2 = this;

      var projection = this.$refs.map.$mapObject.getProjection();

      this.entries.forEach(function (entry) {

        var lineSymbol = {
          geodesic: false,
          path: google.maps.SymbolPath.CIRCLE,
          scale: 2,
          strokeColor: entry.type.color,
          strokeOpacity: 1.0,
          strokeWeight: 4
        };

        var coords = generatePolyPath(entry.locations).map(function (coord) {
          return projection.fromPointToLatLng(new google.maps.Point(coord.x, coord.y));
        });

        var generatedPath = new google.maps.Polyline({
          path: coords,
          icons: [{
            icon: lineSymbol,
            offset: '100%'
          }],
          geodesic: false,
          strokeColor: entry.type.color,
          strokeOpacity: 1.0,
          strokeWeight: 4
        });

        // Paint the path on the map
        generatedPath.setMap(_this2.$refs.map.$mapObject);

        // Animate the symbol
        animateCircle(generatedPath);

        _this2.drawnEntries.push(generatedPath);

        google.maps.event.addListener(lineSymbol, 'click', function (e) {
          _this2.$emit('open', entry.id, e);
        });

        google.maps.event.addListener(generatedPath, 'click', function (e) {
          _this2.$emit('open', entry.id, e);
        });
      });
    },
    restoreCenter: function restoreCenter() {
      var map = this.$refs.map.$mapObject;
      var center = map.getCenter();
      google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
    },
    handleMapTypeIdChange: function handleMapTypeIdChange(mapType) {
      if (mapType === this.name) {
        this.drawEntriesOnce();
      }
    },
    handleMapLoaded: function handleMapLoaded() {
      this.$refs.map.resizePreserveCenter();
      this.mapLoaded = true;

      var name = this.name;

      // Load the custom map
      var sourceImg = this.sourceImg;
      var mapType = new google.maps.ImageMapType({
        getTileUrl: function getTileUrl(rawCoord, zoom) {
          var coord = getNormalizedCoord(rawCoord, zoom);
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__generateTile_js__["a" /* default */])(name, sourceImg, { width: 256, height: 256 }, coord, zoom);
        },
        tileSize: new google.maps.Size(256, 256),
        maxZoom: 8,
        minZoom: 0,
        radius: 1,
        name: name
      });

      this.$refs.map.$mapObject.mapTypes.set(name, mapType);
      this.$refs.map.$mapObject.setMapTypeId(name);
    },
    handleMapClick: function handleMapClick(e) {
      this.$emit('click', e);
    }
  }
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Player',
  props: ['id', 'start', 'end'],
  data: function data() {
    return {
      refreshPlayer: false
    };
  },

  watch: {
    start: function start() {
      this.refresh();
    },
    end: function end() {
      this.refresh();
    }
  },
  computed: {
    videoLength: function videoLength() {
      return this.end - this.start;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resetVideoTimeout) {
      clearTimeout(this.resetVideoTimeout);
    }
  },

  methods: {
    refresh: function refresh() {
      var _this = this;

      this.refreshPlayer = true;
      this.$nextTick(function () {
        _this.refreshPlayer = false;
      });
    },
    handlePlaying: function handlePlaying() {
      var _this2 = this;

      var player = this.$refs.youtube.player;

      this.$emit('playing', player);
      clearTimeout(this.resetVideoTimeout);

      if (!this.start || !this.end) return;

      this.resetVideoTimeout = setTimeout(function () {
        player.seekTo(_this2.start, true);
      }, this.videoLength * 1000);
    },
    getCurrentTime: function getCurrentTime() {
      return this.$refs.youtube.player.getCurrentTime();
    },
    getDuration: function getDuration() {
      return this.$refs.youtube.player.getDuration();
    }
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UserBar__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UserBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_UserBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_QUERY_ENTRIES_FOR_MAP__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_QUERY_GAME_TYPES__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NadeMap__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NadeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_NadeMap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  props: ['user'],
  components: { Logo: __WEBPACK_IMPORTED_MODULE_0__components_Logo___default.a, NadeMap: __WEBPACK_IMPORTED_MODULE_6__components_NadeMap___default.a, Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_Loader___default.a, UserBar: __WEBPACK_IMPORTED_MODULE_3__components_UserBar___default.a },
  data: function data() {
    return {
      selectedType: '',
      selectedUsage: '',
      map: null,
      types: []
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Nadespots - ' + (this.map ? this.map.name : '')
    };
  },


  methods: {
    handleMapOpen: function handleMapOpen(id) {
      this.$router.push({
        name: 'DashboardDetails',
        params: {
          detailId: id
        }
      });
    },
    handleTypeChange: function handleTypeChange(e) {
      console.log('handleTypeChange', e);
      this.selectedType = e.target.value;
    },
    handleUsageChange: function handleUsageChange(e) {
      this.selectedUsage = e.target.value;
    },
    login: function login() {
      this.$refs.userBar.login();
    }
  },
  computed: {
    entries: function entries() {
      var _this = this;

      if (!this.map || !this.map.entries) return [];

      var entries = this.map.entries;

      // Filter entries on type
      if (this.selectedType) {
        entries = entries.filter(function (x) {
          return x.type.id === _this.selectedType;
        });
      }

      // Filter entries on usage
      if (this.selectedUsage) {
        entries = entries.filter(function (x) {
          return x.usage === _this.selectedUsage;
        });
      }

      return entries;
    },
    minimap: function minimap() {
      if (!this.map) return null;

      return {
        url: this.map.minimap,
        size: this.map.minimapSize
      };
    }
  },
  apollo: {
    types: {
      query: __WEBPACK_IMPORTED_MODULE_5__graphql_QUERY_GAME_TYPES__["a" /* default */],
      variables: function variables() {
        return {
          game: this.$route.params.game
        };
      },
      update: function update(data) {
        return data.game.types;
      }
    },
    map: {
      query: __WEBPACK_IMPORTED_MODULE_4__graphql_QUERY_ENTRIES_FOR_MAP__["a" /* default */],
      variables: function variables() {
        return {
          map: this.$route.params.game + '_' + this.$route.params.map
        };
      }
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Logo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Disclaimer',
  components: { Logo: __WEBPACK_IMPORTED_MODULE_0__components_Logo___default.a }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchBar',
  data: function data() {
    return {
      isOpen: false,
      highlightedPosition: 0
    };
  },

  props: {
    keyword: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    }
  },
  computed: {
    fOptions: function fOptions() {
      var re = new RegExp(this.keyword, 'i');
      return this.options.filter(function (o) {
        return o.title.match(re);
      });
    }
  },
  methods: {
    onInput: function onInput(value) {
      this.$emit('input', value);
      this.highlightedPosition = 0;
      this.isOpen = !!value;
    },
    moveDown: function moveDown() {
      if (!this.isOpen) {
        return;
      }
      this.highlightedPosition = (this.highlightedPosition + 1) % this.fOptions.length;
    },
    moveUp: function moveUp() {
      if (!this.isOpen) {
        return;
      }
      this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this.fOptions.length - 1 : this.highlightedPosition - 1;
    },
    select: function select() {
      var selectedOption = this.fOptions[this.highlightedPosition];
      this.$emit('select', selectedOption);
      this.isOpen = false;
      this.keyword = selectedOption.title;
    }
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slug__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SearchBar__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SearchBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SearchBar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var TWITCH_API_KEY = 'atdov855pxy9wlq6wbo6kg3w8psf01';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',
  components: {
    SearchBar: __WEBPACK_IMPORTED_MODULE_4__components_SearchBar___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_Loader___default.a,
    Logo: __WEBPACK_IMPORTED_MODULE_3__components_Logo___default.a
  },
  data: function data() {
    return {
      keyword: '',
      searchValue: '',
      games: [],
      options: [],
      popularGames: [{
        title: 'Battalion 1944',
        slug: 'battalion-1944',
        thumbnail: 'https://www.nadespots.com/cdn/cjdn2vgq5056k01060peajyp8'
      }, {
        title: 'Black Squad',
        slug: 'black-squad',
        thumbnail: 'https://www.nadespots.com/cdn/cjagnywjp02m101568bbio7v2'
      }, {
        title: 'S.K.I.L.L.: Special Force 2',
        slug: 'skill-special-force-2',
        thumbnail: 'https://www.nadespots.com/cdn/cjagny9z102lx0156ndgni4aj'
      }, {
        title: 'Counter Strike: Global Offensive',
        slug: 'counter-strike-global-offensive',
        thumbnail: 'https://www.nadespots.com/cdn/cjagnxfea02lt0156xkmwu3h6'
      }, {
        title: 'Alliance of Valiant Arms',
        slug: 'alliance-of-valiant-arms',
        thumbnail: 'https://www.nadespots.com/cdn/cjagnsw0002hv0183mtgpptw2'
      }, {
        title: 'Warface',
        slug: 'warface',
        thumbnail: 'https://www.nadespots.com/cdn/cjagnwp5l02lh0156fhqmva5p'
        // {
        //   title: 'Line of Sight',
        //   slug: 'line-of-sight',
        //   thumbnail: 'https://www.nadespots.com/cdn/cjaa2otcp03y601419mel2kvj'
        // }
      }]
    };
  },

  computed: {
    fetchTwitchGames: function fetchTwitchGames() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(this.doFetchTwitchGames, 300, { trailing: true });
    }
  },
  methods: {
    doFetchTwitchGames: function doFetchTwitchGames(query) {
      var _this = this;

      var twitchUrl = 'https://api.twitch.tv/kraken/search/games?type=suggest&client_id=' + TWITCH_API_KEY + '&query=' + query;
      fetch(twitchUrl).then(function (response) {
        return response.json();
      }).then(function (result) {
        console.log('twitchUrl', twitchUrl);
        console.log('result', result);

        _this.options = result.games.map(function (game) {
          return {
            title: game.name,
            description: 'No description',
            thumbnail: game.box.small
          };
        });
      });
    },
    handleKeywordChange: function handleKeywordChange(value) {
      this.keyword = value;
      this.fetchTwitchGames(this.keyword);
    },
    handleOptionSelect: function handleOptionSelect(option) {
      var gameSlug = __WEBPACK_IMPORTED_MODULE_1_slug___default()(option.title).toLowerCase();

      this.$router.push({
        name: 'MapSelection',
        params: {
          game: gameSlug,
          name: option.title
        }
      });
    }
  }
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a },
  created: function created() {
    localStorage.removeItem('profile');
    localStorage.removeItem('auth0IdToken');
    window.location.reload(true);
  }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone_dist_vue2Dropzone_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slug__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_lock__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UserBar__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UserBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_UserBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_MUTATION_CREATE_MAP__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_QUERY_GAME_MAPS__ = __webpack_require__(219);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var UPLOAD_LOCATION = 'https://files.graph.cool/cj59tz3nfrlhy0105885qy550/';
var CDN_LOCATION = 'https://www.nadespots.com/cdn/';

var base64ToFile = function base64ToFile(dataURI, origFile) {
  var byteString = void 0,
      mimestring = void 0;

  if (dataURI.split(',')[0].indexOf('base64') !== -1) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = decodeURI(dataURI.split(',')[1]);
  }

  mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0];

  var content = [];
  for (var i = 0; i < byteString.length; i++) {
    content[i] = byteString.charCodeAt(i);
  }

  var newFile = new File([new Uint8Array(content)], origFile.name, { type: mimestring });

  // Copy props set by the dropzone in the original file
  var origProps = ['upload', 'status', 'previewElement', 'previewTemplate', 'accepted'];

  origProps.forEach(function (p) {
    newFile[p] = origFile[p];
  });

  return newFile;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddMap',
  components: { Dropzone: __WEBPACK_IMPORTED_MODULE_0_vue2_dropzone___default.a, UserBar: __WEBPACK_IMPORTED_MODULE_4__components_UserBar___default.a },
  props: ['user'],
  data: function data() {
    return {
      lock: __WEBPACK_IMPORTED_MODULE_3__services_lock__["a" /* default */],
      name: '',
      thumbnail: null,
      minimap: null,
      incompleteError: false,
      existError: false
    };
  },

  apollo: {
    game: {
      query: __WEBPACK_IMPORTED_MODULE_6__graphql_QUERY_GAME_MAPS__["a" /* default */],
      variables: function variables() {
        return {
          game: this.$route.params.game || ''
        };
      },
      update: function update(data) {
        return data.game ? data.game.id : null;
      },
      result: function result(_ref) {
        var data = _ref.data;

        if (!data.game && this.$route.params.name) {
          this.createGame(this.$route.params.name, this.$route.params.game);
        }
      }
    },
    maps: {
      query: __WEBPACK_IMPORTED_MODULE_6__graphql_QUERY_GAME_MAPS__["a" /* default */],
      variables: function variables() {
        return {
          game: this.$route.params.game || ''
        };
      },
      update: function update(data) {
        return data.game ? data.game.maps : [];
      },

      loadingKey: 'fetchingMaps'
    }
  },
  methods: {
    thumbnailSuccess: function thumbnailSuccess(file, jsonResult) {
      var result = JSON.parse(jsonResult);
      var url = result.url.replace(UPLOAD_LOCATION, CDN_LOCATION);
      this.thumbnail = url;
    },
    minimapSuccess: function minimapSuccess(file, jsonResult) {
      var result = JSON.parse(jsonResult);
      var url = result.url.replace(UPLOAD_LOCATION, CDN_LOCATION);
      this.minimap = url;
    },
    showLock: function showLock() {
      this.lock.show();
    },
    handleProcessing: function handleProcessing(file) {
      console.log('handleProcessing', file);
    },
    handleFileAdded: function handleFileAdded(origFile) {
      console.log('handleFileAddedl', origFile);

      var dropzone = this.$refs.mapDropzone.dropzone;
      var reader = new FileReader();

      var newWidth = dropzone.options.resizeWidth;
      var newHeight = dropzone.options.resizeHeight;

      // Convert file to img
      reader.addEventListener('load', function (event) {
        var origImg = new Image();
        origImg.src = event.target.result;

        origImg.addEventListener('load', function (event) {
          var width = event.target.width;
          var height = event.target.height;

          // Calc new dims otherwise
          if (width > height) {
            height *= newWidth / width;
            width = newWidth;
          } else {
            width *= newHeight / height;
            height = newHeight;
          }

          // Resize
          var canvas = document.createElement('canvas');
          canvas.width = newWidth;
          canvas.height = newHeight;

          var ctx = canvas.getContext('2d');
          ctx.fillStyle = 'grey';
          ctx.fillRect(0, 0, newWidth, newHeight);

          var newX = (newWidth - width) / 2;
          var newY = (newHeight - height) / 2;
          ctx.drawImage(origImg, newX, newY, width, height);

          var resizedFile = base64ToFile(canvas.toDataURL(), origFile);

          // Replace original with resized
          var origFileIndex = dropzone.files.indexOf(origFile);
          dropzone.files[origFileIndex] = resizedFile;

          // Enqueue added file manually making it available for
          // further processing by dropzone
          dropzone.enqueueFile(resizedFile);
        });
      });

      reader.readAsDataURL(origFile);
    },
    handleCreateMap: function handleCreateMap() {
      var _this = this;

      if (!this.name || !this.thumbnail || !this.minimap) {
        this.incompleteError = true;
        return;
      }
      var gameSlug = this.$route.params.game || '';
      var slug = gameSlug + '_' + this.slug;

      if (this.maps.filter(function (x) {
        return x.slug === slug;
      }).length > 0) {
        this.existError = true;
        return;
      }

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_5__graphql_MUTATION_CREATE_MAP__["a" /* default */],
        variables: {
          minimapSize: 1024,
          slug: slug,
          game: this.game,
          minimap: this.minimap,
          thumbnail: this.thumbnail,
          name: this.name,
          userId: this.user.id
        },
        update: function update(store, _ref2) {
          var createMap = _ref2.data.createMap;

          console.log('update', store, createMap, this);
          var data = store.readQuery({
            query: __WEBPACK_IMPORTED_MODULE_6__graphql_QUERY_GAME_MAPS__["a" /* default */],
            variables: {
              game: gameSlug
            }
          });
          console.log('data', data);
          data.game.maps.push(createMap);
          store.writeQuery({ query: __WEBPACK_IMPORTED_MODULE_6__graphql_QUERY_GAME_MAPS__["a" /* default */], data: data });
        }
      }).then(function (data) {
        console.log('mapEntry success', data);
        _this.$router.push({ name: 'MapSelection' });
      }).catch(function (error) {
        console.error('mapEntry error', error);
      });
    }
  },
  computed: {
    slug: function slug() {
      return __WEBPACK_IMPORTED_MODULE_2_slug___default()(this.name).toLowerCase();
    }
  }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loader__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_GAME_MAPS__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_MUTATION_ADD_GAME__ = __webpack_require__(412);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MapSelection',

  components: { Logo: __WEBPACK_IMPORTED_MODULE_0__components_Logo___default.a, Loader: __WEBPACK_IMPORTED_MODULE_1__components_Loader___default.a, Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal___default.a },

  props: ['user'],

  data: function data() {
    return {
      game: null,
      maps: [],
      fetchingMaps: 0
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Nadespots - ' + this.name
    };
  },


  apollo: {
    name: {
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_GAME_MAPS__["a" /* default */],
      variables: function variables() {
        return {
          game: this.$route.params.game || ''
        };
      },
      update: function update(data) {
        return data.game ? data.game.name : null;
      }
    },
    game: {
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_GAME_MAPS__["a" /* default */],
      variables: function variables() {
        return {
          game: this.$route.params.game || ''
        };
      },
      update: function update(data) {
        return data.game ? data.game.id : null;
      },
      result: function result(_ref) {
        var data = _ref.data;

        if (!data.game && this.$route.params.name) {
          this.createGame(this.$route.params.name, this.$route.params.game);
        }
      }
    },
    maps: {
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_GAME_MAPS__["a" /* default */],
      variables: function variables() {
        return {
          game: this.$route.params.game || ''
        };
      },
      update: function update(data) {
        return data.game ? data.game.maps : [];
      },

      loadingKey: 'fetchingMaps'
    }
  },
  methods: {
    createLink: function createLink(slug) {
      return slug.split('_').slice(-1)[0];
    },
    createGame: function createGame(name, slug) {
      console.log('createGame', name, slug);
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_MUTATION_ADD_GAME__["a" /* default */],
        variables: {
          slug: slug,
          name: name
        },
        update: function update(store, _ref2) {
          var createGame = _ref2.data.createGame;

          console.log('update', store, createGame);
          var data = store.readQuery({
            query: __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_GAME_MAPS__["a" /* default */],
            variables: {
              game: slug
            }
          });
          console.log('data', data);
          data.game = createGame;
          store.writeQuery({ query: __WEBPACK_IMPORTED_MODULE_3__graphql_QUERY_GAME_MAPS__["a" /* default */], data: data });
        }
      });
    }
  }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Logo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Terms',
  components: { Logo: __WEBPACK_IMPORTED_MODULE_0__components_Logo___default.a }
});

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 529:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 533:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/github.c152728.png";

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/netlify.f0f73a9.png";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(712),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2aa06ab5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(707),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-190a413e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(730),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
  __webpack_require__(517)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(710),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-382fca68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(724),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b60fe50e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(727),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c1c8e928",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(713),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ea7daf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12f9d630",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(723),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(533)
  __webpack_require__(532)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(729),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e60d8bda",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7188d5a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(726),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bba4e4a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(719),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(714),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(705),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(716),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(728),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(717),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('logo'), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Learn nades the easy way.")]), _vm._v(" "), _c('div', {
    staticClass: "search row"
  }, [_c('div', {
    staticClass: "search__content col-xs-12"
  }, [_c('search-bar', {
    attrs: {
      "keyword": _vm.keyword,
      "options": _vm.options,
      "placeholder": "Search a game"
    },
    on: {
      "input": _vm.handleKeywordChange,
      "select": _vm.handleOptionSelect
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "popular row center-xs"
  }, _vm._l((_vm.popularGames), function(game) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-3 col-md-2 col-lg-2"
    }, [_c('div', {
      staticClass: "popular__item drop-shadow",
      style: (("background-image:url(" + (game.thumbnail) + ")"))
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'MapSelection',
          params: {
            game: game.slug
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(game.title) + "\n        ")])], 1)])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popular-title row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "popular-title__content"
  }, [_c('h2', [_vm._v("\n          Popular games:\n        ")])])])])
}]}

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row input-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v("\n        Name: "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "A descriptive name like: Nade from A to Mid"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n        Type: "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleTypeChange
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\n            " + _vm._s(type.name) + "\n          ")])
  }))]), _vm._v(" "), _c('div', [_vm._v("\n        Usage: "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleUsageChange
    }
  }, _vm._l((_vm.usages), function(usage) {
    return _c('option', {
      domProps: {
        "value": usage
      }
    }, [_vm._v("\n            " + _vm._s(usage) + "\n          ")])
  }))]), _vm._v(" "), _c('div', [_vm._v("\n        Description: "), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "placeholder": "Where do we need to look? When do we need to throw? Do we need to run and jump?"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 center-xs"
  }, [_c('div', {
    staticClass: "box map-container"
  }, [_c('span', [_vm._v("\n        Draw a line by clicking on the map\n      ")]), _vm._v(" "), (_vm.minimap) ? _c('nade-map', {
    attrs: {
      "name": _vm.$route.params.map,
      "minimap": _vm.minimap,
      "entries": _vm.entry.type && [_vm.entry],
      "draggable": false
    },
    on: {
      "click": _vm.handleMapClick,
      "rightclick": _vm.handleMapRightClick
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reset-button-container"
  }, [_c('a', {
    staticClass: "reset-button",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.handleMapRightClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-loop-strong"
  }), _vm._v("\n          Reset\n        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 center-xs"
  }, [_c('div', {
    staticClass: "next-button-container"
  }, [(_vm.$v.$invalid) ? _c('a', {
    staticClass: "disabled-button"
  }, [_c('i', {
    staticClass: "icon ion-alert-circled"
  }), _vm._v("\n        Enter the required fields\n      ")]) : _c('router-link', {
    staticClass: "next-button",
    attrs: {
      "to": {
        name: 'DashboardAddContent',
        params: {
          name: this.name,
          description: this.description,
          locations: this.locations,
          type: this.type || this.types[0].id,
          usage: this.usage || this.usages[0]
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-checkmark"
  }), _vm._v("\n        Next step\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("\n      Add a new nade\n    ")])])
}]}

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row input-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n      Search on YouTube:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.handleSearchInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box found-videos"
  }, [(_vm.searchLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.foundVideos.length === 0) ? _c('span', [_vm._v("No videos found.")]) : _c('ul', _vm._l((_vm.foundVideos), function(foundVideo) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.selectVideo(foundVideo.id.videoId)
        }
      }
    }, [_c('div', {
      staticClass: "video-item"
    }, [_c('div', {
      staticClass: "video-image"
    }, [_c('img', {
      attrs: {
        "src": foundVideo.snippet.thumbnails.default.url,
        "alt": foundVideo.snippet.title,
        "width": foundVideo.snippet.thumbnails.default.width,
        "height": foundVideo.snippet.thumbnails.default.height
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "video-padder"
    }), _vm._v(" "), _c('div', {
      staticClass: "video-description"
    }, [_vm._v("\n              " + _vm._s(foundVideo.snippet.title) + "\n            ")])])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n      Enter YouTube video id or url here:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video),
      expression: "video"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.video)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.video && _vm.video.length > 0) ? _c('player', {
    ref: "player",
    attrs: {
      "id": _vm.video,
      "start": parseInt(_vm.start, 10),
      "end": parseInt(_vm.end, 10)
    },
    on: {
      "playing": _vm.handleVideo,
      "ready": _vm.handleVideo
    }
  }) : _c('span', [_vm._v("\n        Select a video.\n      ")]), _vm._v(" "), (_vm.end > 0) ? _c('vue-slider', {
    ref: "slider",
    staticClass: "slider",
    attrs: {
      "value": _vm.sliderValues,
      "tooltip": "always",
      "formatter": function (x) {
        return _vm.toHHMMSS(x)
      },
      "min": _vm.min,
      "max": _vm.max,
      "tooltipDir": ['top', 'bottom'],
      "dot-size": 10
    },
    on: {
      "drag-end": _vm.handleDragEnd
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "box"
  }, [(!_vm.recording) ? _c('button', {
    on: {
      "click": _vm.handleStartRecord
    }
  }, [_vm._v("\n        Record\n      ")]) : _c('button', {
    on: {
      "click": _vm.handleStopRecord
    }
  }, [_vm._v("\n        Stop recording\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 center-xs"
  }, [_c('div', {
    staticClass: "next-button-container"
  }, [(_vm.valid) ? _c('a', {
    staticClass: "disabled-button"
  }, [_c('i', {
    staticClass: "icon ion-alert-circled"
  }), _vm._v("\n        Enter the required fields\n      ")]) : _c('a', {
    staticClass: "default-button",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addEntry($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-checkmark"
  }), _vm._v("\n        Create entry\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("\n      Select your video\n    ")])])
}]}

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-container",
    on: {
      "scroll": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "scroll": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-close"
  })]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entry) ? _c('div', {
    staticClass: "details-container"
  }, [_c('div', {
    staticClass: "details-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.entry.name || ''))]), _vm._v(" "), _c('h2', [_vm._v("By " + _vm._s(_vm.entry.user && _vm.entry.user.name ? _vm.entry.user.name : 'unknown'))])]), _vm._v(" "), _c('div', {
    staticClass: "details row center-xs left-md"
  }, [_c('div', {
    staticClass: "details-menu col-xs-12 col-sm-12 col-md-12 col-lg-3 last-xs last-sm last-md"
  }, [_c('div', {
    staticClass: "row center-xs"
  }, [(_vm.entry && _vm.entry.description) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 first-xs first-sm first-md last-lg"
  }, [_c('div', {
    staticClass: "content description"
  }, [_c('h3', [_vm._v("Description")]), _vm._v("\n              " + _vm._s(_vm.entry.description || '') + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.detailId) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 first-xs first-sm first-md last-lg"
  }, [_c('div', {
    staticClass: "content description"
  }, [_c('h3', [_vm._v("Discussion")]), _vm._v(" "), _c('vue-disqus', {
    attrs: {
      "title": _vm.entry && _vm.entry.name ? _vm.entry.name : '',
      "shortname": "nadespots",
      "identifier": _vm.$route.params.detailId
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-content col-xs-12 col-sm-12 col-md-12 col-lg-9 last-lg"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.entry && _vm.entry.video && _vm.entry.video.videoId) ? _c('player', {
    attrs: {
      "id": _vm.entry.video.videoId,
      "start": _vm.entry.video.start,
      "end": _vm.entry.video.end
    }
  }) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('router-view', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__left"
  }, [_c('a', {
    attrs: {
      "href": "https://graph.cool",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.graphcoolBadge,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://netlify.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.netlifyBadge,
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/nielslanting/nade-spots",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.githubBadge,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer__right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Disclaimer'
      }
    }
  }, [_vm._v("\n        Dislaimer\n      ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Terms'
      }
    }
  }, [_vm._v("\n        Terms\n      ")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("wat")])
},staticRenderFns: []}

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-input"
  }, [_c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    staticClass: "input is-large",
    attrs: {
      "placeholder": this.placeholder || 'Search'
    },
    domProps: {
      "value": _vm.keyword
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.isOpen = false
      },
      "blur": function($event) {
        _vm.isOpen = false
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.moveDown($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.moveUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.select($event)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "options-list"
  }, _vm._l((_vm.fOptions), function(option, index) {
    return _c('li', {
      class: {
        'highlighted': index === _vm.highlightedPosition
      },
      on: {
        "mouseenter": function($event) {
          _vm.highlightedPosition = index
        },
        "mousedown": _vm.select
      }
    }, [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": option.thumbnail
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "media-right"
    }, [_c('strong', [_vm._v(_vm._s(option.title))])])])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.user) ? _c('div', {
    staticClass: "row end-xs"
  }, [_c('div', {
    staticClass: "row end-xs"
  }, [_c('button', {
    staticClass: "login-button",
    on: {
      "click": _vm.login
    }
  }, [_c('i', {
    staticClass: "icon ion-log-in"
  }), _vm._v("\n      Login\n    ")])])]) : _c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "user-bar row middle-xs"
  }, [_c('div', {
    staticClass: "username-container col-xs-6 middle-xs"
  }, [(!_vm.isUsernameEditable) ? _c('span', {
    on: {
      "click": _vm.handleUserNameEditClick
    }
  }, [_vm._v("\n        " + _vm._s(_vm.user.name) + "\n        "), _c('i', {
    staticClass: "icon ion-edit"
  })]) : _c('input', {
    ref: "userNameInput",
    staticClass: "user-name-input",
    domProps: {
      "value": _vm.editableUsername
    },
    on: {
      "input": _vm.handleUserNameInput,
      "blur": _vm.handleUserNameBlur,
      "keypress": _vm.handleUserNameKeyPress
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 middle-xs"
  }, [_c('button', {
    staticClass: "logout-button",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon ion-log-out"
  }), _vm._v("\n        Logout\n      ")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('logo', {
    attrs: {
      "no-header": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map-title row"
  }, [_c('div', {
    staticClass: "map-title__content col-xs-12 "
  }, [_c('h1', {
    staticClass: "map-title__title"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + " nade spots\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Select the map you want to learn nade spots for.   \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "map-title__back-button-container"
  }, [_c('router-link', {
    staticClass: "map-title__back-button",
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Choose another game\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maps && _vm.maps.length > 0),
      expression: "maps && maps.length > 0"
    }],
    staticClass: "map-selection row center-xs"
  }, _vm._l((_vm.maps), function(map) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
    }, [_c('div', {
      staticClass: "map-selection__item box dropShadow",
      style: (("background-image:url(" + (map.thumbnail) + ")"))
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Dashboard',
          params: {
            map: _vm.createLink(map.slug)
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(map.name) + "\n        ")])], 1)])
  })), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchingMaps),
      expression: "fetchingMaps"
    }]
  }, [_c('loader')], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fetchingMaps && (!_vm.maps || _vm.maps.length === 0)),
      expression: "!fetchingMaps && (!maps || maps.length === 0)"
    }],
    staticClass: "no-maps-found"
  }, [_vm._v("\n    No maps found for this game.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "add-map row center-xs"
  }, [_c('router-link', {
    staticClass: "add-map__button",
    attrs: {
      "to": {
        name: 'MapSelectionAdd'
      }
    }
  }, [_vm._v("\n      Add a map\n    ")])], 1), _vm._v(" "), (_vm.$route.name !== 'MapSelection') ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.$router.push({
          name: 'MapSelection'
        })
      }
    }
  }, [_c('router-view', {
    attrs: {
      "user": _vm.user
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideImage),
      expression: "!hideImage"
    }],
    staticClass: "logo__img",
    style: ({
      height: 100,
      width: 100
    }),
    attrs: {
      "src": __webpack_require__(293),
      "alt": "Nadespots logo"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [(!_vm.noHeader) ? _c('h1', [_vm._v("\n      Nade"), _c('em', [_vm._v("spots")])]) : _c('div', {
    staticClass: "logo__title"
  }, [_vm._v("\n      Nade"), _c('em', [_vm._v("spots")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video"
  }, [(!_vm.refreshPlayer) ? _c('youtube', {
    ref: "youtube",
    staticClass: "item",
    attrs: {
      "player-width": "100%",
      "player-height": "100%",
      "video-id": _vm.id,
      "mute": true,
      "player-vars": {
        autoplay: 1,
        start: _vm.start ? _vm.start : undefined,
        end: _vm.end ? (_vm.end + 2) : undefined,
        modestbranding: 1,
        iv_load_policy: 3
      }
    },
    on: {
      "playing": _vm.handlePlaying,
      "ready": function($event) {
        _vm.$emit('ready')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "map-container"
  }, [_c('gmap-map', {
    ref: "map",
    class: {
      map: true, loaded: _vm.mapLoaded
    },
    attrs: {
      "center": {
        lat: 0,
        lng: 0
      },
      "streetViewControl": false,
      "options": {
        streetViewControl: false,
        mapTypeControl: false,
        draggable: this.draggable != null ? this.draggable : true
      },
      "zoom": 1,
      "mapTypeControl": false
    },
    on: {
      "maptypeid_changed": _vm.handleMapTypeIdChange,
      "click": _vm.handleMapClick,
      "rightclick": function($event) {
        _vm.$emit('rightclick')
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader'), _vm._v(" \n  Logging out...\n")], 1)
},staticRenderFns: []}

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-6 col-lg-6"
  }, [_c('logo', {
    attrs: {
      "hideImage": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-0 col-sm-3 col-md-1 col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "header__user-bar col-xs-12 col-sm-5 col-md-5 col-lg-5 end-xs"
  }, [_c('user-bar', {
    ref: "userBar",
    attrs: {
      "user": _vm.user
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row center-xs"
  }, [_c('aside', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "box back-button"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MapSelection'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Map selection\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box add-button"
  }, [(_vm.user) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'DashboardAddDetails'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-plus-round"
  }), _vm._v("\n            Add new\n          ")]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.login($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-plus-round"
  }), _vm._v("\n            Login to add new\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box side-menu"
  }, [_c('div', [_c('b', [_vm._v("Type:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleTypeChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _vm._l((_vm.types), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\n                " + _vm._s(type.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Usage:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleUsageChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("General")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OFFENSIVE"
    }
  }, [_vm._v("Offensive")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DEFENSIVE"
    }
  }, [_vm._v("Defensive")])])])])]), _vm._v(" "), _c('main', {
    staticClass: "map col-xs-12 col-sm-8 col-md-9 col-lg-9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.map && _vm.minimap) ? _c('nade-map', {
    attrs: {
      "name": _vm.$route.params.map,
      "minimap": _vm.minimap,
      "entries": _vm.entries
    },
    on: {
      "open": _vm.handleMapOpen
    }
  }) : _c('div', {
    staticClass: "map__loader"
  }, [_c('loader')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "legend col-xs-12 col-sm-offset-4 col-sm-8 col-md-offset-3 col-md-9 col-lg-offset-3 col-lg-9"
  }, [_c('div', {
    staticClass: "box"
  }, _vm._l((_vm.types), function(type) {
    return _c('div', {
      staticClass: "legend__item"
    }, [_c('div', {
      staticClass: "legend__circle",
      style: (("background-color: " + (type.color)))
    }), _vm._v("\n            " + _vm._s(type.name) + "\n          ")])
  }))]), _vm._v(" "), (_vm.$route.name !== 'Dashboard') ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.$router.push({
          name: 'Dashboard'
        })
      }
    }
  }, [_c('router-view', {
    attrs: {
      "entries": _vm.entries,
      "map": _vm.map,
      "types": _vm.types,
      "minimap": _vm.minimap,
      "user": _vm.user
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('i', {
    staticClass: "ion-ios-help-outline"
  }), _vm._v(" Click on a line to see the details of the nade\n        ")])
}]}

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-folding-cube"
  }, [_c('div', {
    staticClass: "sk-cube1 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube2 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube4 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube3 sk-cube"
  })])
}]}

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "terms__logo"
  }, [_c('logo')], 1), _vm._v(" "), _c('div', {
    staticClass: "terms__back"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Back to home\n      ")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "terms__back"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Back to home\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms__box"
  }, [_c('h2', [_vm._v("\n        Nadespots Terms of Service\n      ")]), _vm._v(" "), _c('h3', [_vm._v("1. Terms")]), _vm._v(" "), _c('p', [_vm._v("By accessing the website at "), _c('a', {
    attrs: {
      "href": "https://www.nadespots.com"
    }
  }, [_vm._v("https://www.nadespots.com")]), _vm._v(", you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.")]), _vm._v(" "), _c('h3', [_vm._v("2. Use License")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_vm._v("Permission is granted to temporarily download one copy of the materials (information or software) on Nadespots' website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:\n         "), _c('ol', {
    attrs: {
      "type": "i"
    }
  }, [_c('li', [_vm._v("modify or copy the materials;")]), _vm._v(" "), _c('li', [_vm._v("use the materials for any commercial purpose, or for any public display (commercial or non-commercial);")]), _vm._v(" "), _c('li', [_vm._v("attempt to decompile or reverse engineer any software contained on Nadespots' website;")]), _vm._v(" "), _c('li', [_vm._v("remove any copyright or other proprietary notations from the materials; or")]), _vm._v(" "), _c('li', [_vm._v("transfer the materials to another person or \"mirror\" the materials on any other server.")])])]), _vm._v(" "), _c('li', [_vm._v("This license shall automatically terminate if you violate any of these restrictions and may be terminated by Nadespots at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.")])]), _vm._v(" "), _c('h3', [_vm._v("3. Disclaimer")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_vm._v("The materials on Nadespots' website are provided on an 'as is' basis. Nadespots makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.")]), _vm._v(" "), _c('li', [_vm._v("Further, Nadespots does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.")])]), _vm._v(" "), _c('h3', [_vm._v("4. Limitations")]), _vm._v(" "), _c('p', [_vm._v("In no event shall Nadespots or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Nadespots' website, even if Nadespots or a Nadespots authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.")]), _vm._v(" "), _c('h3', [_vm._v("5. Accuracy of materials")]), _vm._v(" "), _c('p', [_vm._v("The materials appearing on Nadespots website could include technical, typographical, or photographic errors. Nadespots does not warrant that any of the materials on its website are accurate, complete or current. Nadespots may make changes to the materials contained on its website at any time without notice. However Nadespots does not make any commitment to update the materials.")]), _vm._v(" "), _c('h3', [_vm._v("6. Links")]), _vm._v(" "), _c('p', [_vm._v("Nadespots has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Nadespots of the site. Use of any such linked website is at the user's own risk.")]), _vm._v(" "), _c('h3', [_vm._v("7. Modifications")]), _vm._v(" "), _c('p', [_vm._v("Nadespots may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.")]), _vm._v(" "), _c('h3', [_vm._v("8. Governing Law")]), _vm._v(" "), _c('p', [_vm._v("These terms and conditions are governed by and construed in accordance with the laws of Netherlands and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.")])])
}]}

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimer row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "disclaimer__logo"
  }, [_c('logo')], 1), _vm._v(" "), _c('div', {
    staticClass: "disclaimer__back"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Back to home\n      ")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "disclaimer__back"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Back to home\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimer__box"
  }, [_c('h2', [_vm._v("\n        Disclaimer\n      ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("\n          Last updated: November 22, 2017\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        The information contained on "), _c('a', {
    attrs: {
      "href": "https://www.nadespots.com"
    }
  }, [_vm._v("https://www.nadespots.com")]), _vm._v(" website (the \"Service\") is for general information purposes only.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Nadespots assumes no responsibility for errors or omissions in the contents on the Service.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        In no event shall Nadespots be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. Nadespots reserves the right to make additions, deletions, or modification to the contents on the Service at any time without prior notice.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Nadespots does not warrant that the website is free of viruses or other harmful components.\n      ")]), _vm._v(" "), _c('h2', [_vm._v("\n        External links disclaimer\n      ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.nadespots.com"
    }
  }, [_vm._v("https://www.nadespots.com")]), _vm._v(" website may contain links to external websites that are not provided or maintained by or in any way affiliated with Nadespots\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Please note that the Nadespots does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.\n      ")])])
}]}

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-map"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-button"
  }, [_c('user-bar')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n\n        Map Name:\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Map name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n\n        Thumbnail:\n        "), _c('dropzone', {
    staticClass: "thumbnailDropzone",
    attrs: {
      "id": "thumbnailDropzone",
      "options": {
        url: 'https://api.graph.cool/file/v1/cj59tz3nfrlhy0105885qy550',
        paramName: 'data',
        useFontAwesome: true,
        maxNumberOfFiles: 1,
      }
    },
    on: {
      "vdropzone-success": _vm.thumbnailSuccess
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("\n\n        Map:\n        "), _c('dropzone', {
    ref: "mapDropzone",
    staticClass: "mapDropzone",
    attrs: {
      "id": "mapDropzone",
      "options": {
        autoQueue: false,
        url: 'https://api.graph.cool/file/v1/cj59tz3nfrlhy0105885qy550',
        paramName: 'data',
        useFontAwesome: true,
        maxNumberOfFiles: 1,
        resizeWidth: 1024,
        resizeHeight: 1024,
        resizeQuality: 1.0,
        resizeMethod: 'contain'
      }
    },
    on: {
      "vdropzone-success": _vm.minimapSuccess,
      "vdropzone-processing": _vm.handleProcessing,
      "vdropzone-file-added": _vm.handleFileAdded
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.incompleteError),
      expression: "incompleteError"
    }],
    staticClass: "row"
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.existError),
      expression: "existError"
    }],
    staticClass: "row"
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "submit"
  }, [(_vm.user) ? _c('button', {
    staticClass: "submit__button",
    on: {
      "click": _vm.handleCreateMap
    }
  }, [_vm._v("\n          Create map\n        ")]) : _c('button', {
    staticClass: "submit__button",
    on: {
      "click": _vm.showLock
    }
  }, [_vm._v("\n          Signin first\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("\n        Add a new map\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "background-color": "#e74c3c"
    }
  }, [_c('b', [_vm._v("Warning: ")]), _vm._v(" Please enter all the fields!\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "background-color": "#e74c3c"
    }
  }, [_c('b', [_vm._v("Warning: ")]), _vm._v(" This map already exists!\n      ")])])
}]}

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-container"
  }, [_c('router-view', {
    attrs: {
      "user": _vm.user,
      "types": _vm.types,
      "usages": _vm.usages,
      "minimap": _vm.minimap,
      "map": _vm.map
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var Component = __webpack_require__(6)(
  /* script */
  null,
  /* template */
  __webpack_require__(725),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b9ce25dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(720),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c21c46a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[418]);


// WEBPACK FOOTER //
// static/js/app.0126e75894185b716460.js